<template>
  <div>
    <a-row style="min-height: 500px">
      <a-col :span="11" style="padding-right: 10px">
        <a-row class="iotplt-card-box" style="min-height: 100px">
          <h1>{{ product.name }}</h1>
          <p>{{ sgpDisplay }}</p>
        </a-row>

        <a-row class="iotplt-card-box" style="margin-top: 10px">
          <a-descriptions title="eSIM信息" :column="1" class="iotplt-descriptions">
            <a-descriptions-item label="产品名称">
              {{ product.name }}
            </a-descriptions-item>
            <a-descriptions-item label="SGP规范">
              {{ sgpDisplay }}
            </a-descriptions-item>
          </a-descriptions>

          <a-descriptions title="卡板价格" :column="1" />

          <a-descriptions
            :column="1"
            class="iotplt-descriptions iotplt-descriptions-max-9 card-price-wrapper"
          >
            <a-descriptions-item
              v-for="ct in cardTypes"
              :label="ct.card_type_name"
              :key="ct.card_type_id"
            >
              {{ ct.price }}
            </a-descriptions-item>
          </a-descriptions>
        </a-row>
      </a-col>

      <a-col :span="13">
        <a-row class="iotplt-card-box">
          <a-descriptions title="采购信息" :column="1" />
          <a-form class="iotplt-compact-form" :form="form" @submit="handleSubmit">
            <a-form-item
              label="卡片材质"
              :style="{ marginBottom: 0 }"
            >
              <a-spin :spinning="loadingCardTypeOptions">
                <a-radio-group
                  button-style="solid"
                  @change="handleCardTypeChange"
                  v-decorator="['card_type_id', {
                    rules: [{ required: true, message: '请选择卡片材质' }]
                  }]"
                >
                  <a-radio-button
                    class="card-select-box card-type-box"
                    v-for="ct in cardTypes"
                    :key="ct.card_type_id"
                    :value="ct.card_type_id"
                  >
                    {{ ct.card_type_name }}
                  </a-radio-button>
                </a-radio-group>
              </a-spin>
            </a-form-item>

            <a-form-item
              label="卡片尺寸"
              :style="{ marginBottom: 0, minHeight: '91px' }"
            >
              <a-spin :spinning="loadingCardShapeOptions">
                <a-radio-group
                  button-style="solid"
                  v-decorator="['card_shape_id', {
                    rules: [{ required: true, message: '请选择卡片尺寸' }]
                  }]"
                >
                  <a-radio-button
                    class="card-select-box card-shape-box"
                    v-for="cardShape in cardShapeOptions"
                    :key="cardShape.id"
                    :value="cardShape.id"
                  >
                    {{ cardShape.name }}
                  </a-radio-button>
                </a-radio-group>
              </a-spin>
            </a-form-item>

            <a-form-item label="采购数量" required="required">
              <a-space>
                <a-input-number
                  :min="1"
                  :max="10000000"
                  :step="1"
                  :precision="0"
                  style="width: 120px"
                  @change="handleProductCountChange"
                  v-decorator="['product_count', {
                    rules: [{ required: true, message: '请输入采购数量' }]
                  }]"
                />
                <span>张</span>
              </a-space>
            </a-form-item>

            <a-form-item label="备注">
              <a-textarea
                v-decorator="['remark', {
                  rules: [{ max: 200, message: '最多200个字符' }]
                }]"
                :auto-size="{ minRows: 2, maxRows: 5 }"
              />
            </a-form-item>

            <a-descriptions :column="1" class="iotplt-descriptions iotplt-descriptions-max-6">
              <a-descriptions-item label="费用(元)">
                {{ feeDisplay }}
              </a-descriptions-item>
              <a-descriptions-item label="小计(元)">
                {{ feeDisplay }}
              </a-descriptions-item>
            </a-descriptions>

            <a-form-item>
              <a-space>
                <a-button type="primary" html-type="submit" :loading="submitting">
                  加入购物车
                </a-button>
                <a-button @click="$router.push({ name: 'esim_goods' })">返回</a-button>
              </a-space>
            </a-form-item>
          </a-form>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { findEsimGoodsInfo } from '@/api/esim_goods'
import { findCardShapeOptions } from '@/api/common_options'
import { createAgentPurchaseItem, calculateAgentPurchaseItemFee } from '@/api/agent_purchase_item'
import { formatFloat } from '@/utils/filter'

export default {
  name: 'NewEsimPurchaseItem',
  data() {
    this.calculateFee = this.$lodash.debounce(this.calculateFee, 400)
    return {
      form: this.$form.createForm(this, { name: 'new_esim_purchase_item' }),
      product: {},
      cardTypes: [],
      cardShapeOptions: [],
      loadingCardTypeOptions: false,
      loadingCardShapeOptions: false,
      goodsId: 0,
      submitting: false,
      feeDisplay: '',
      totalFee: undefined
    }
  },
  computed: {
    sgpDisplay() {
      const names = this.product.sgp_spec_names
      if (Array.isArray(names)) {
        return names.join('、') || '-'
      }
      return names || '-'
    }
  },
  created() {
    this.goodsId = parseInt(this.$route.query.goods_id, 10) || 0
    this.fetchGoodsInfo()
  },
  methods: {
    fetchGoodsInfo() {
      this.loadingCardTypeOptions = true
      findEsimGoodsInfo(this.goodsId, {
        agent_id: this.$store.getters.userAgentId
      }).then((res) => {
        if (res.code === 0) {
          this.product = res.data || {}
          this.cardTypes = this.product.agents_esim_products_card_types || []
          this.loadingCardTypeOptions = false
          const cardTypeId = this.cardTypes[0] ? this.cardTypes[0].card_type_id : undefined
          this.form.setFieldsValue({
            card_type_id: cardTypeId
          })
          this.fetchCardShapesData(cardTypeId)
        } else {
          this.loadingCardTypeOptions = false
        }
      }).catch(() => {
        this.loadingCardTypeOptions = false
      })
    },

    fetchCardShapesData(cardTypeId) {
      if (!cardTypeId) {
        this.loadingCardShapeOptions = false
        return
      }
      findCardShapeOptions(cardTypeId).then((res) => {
        if (res.code === 0) {
          this.loadingCardShapeOptions = false
          this.cardShapeOptions = res.data || []
          if (this.cardShapeOptions[0]) {
            this.form.setFieldsValue({
              card_shape_id: this.cardShapeOptions[0].id
            })
          }
          this.calculateFee()
        } else {
          this.loadingCardShapeOptions = false
        }
      }).catch(() => {
        this.loadingCardShapeOptions = false
      })
    },

    handleCardTypeChange(e) {
      this.feeDisplay = ''
      this.totalFee = undefined
      const cardTypeId = e.target.value
      this.loadingCardShapeOptions = true
      this.cardShapeOptions = []
      this.form.setFieldsValue({
        card_shape_id: undefined
      })
      if (cardTypeId) {
        this.fetchCardShapesData(cardTypeId)
      }
    },

    handleProductCountChange(count) {
      this.feeDisplay = ''
      this.totalFee = undefined
      if (count > 0) {
        this.calculateFee()
      }
    },

    calculateFee() {
      this.form.validateFields(['card_type_id', 'product_count'], { force: true }, (err, values) => {
        if (err) return
        calculateAgentPurchaseItemFee({
          agent_id: this.$store.getters.userAgentId,
          product_type_slug: 'esim',
          goods_id: this.goodsId,
          card_type_id: values.card_type_id,
          product_count: values.product_count
        }).then((res) => {
          if (res.code === 0) {
            this.totalFee = res.data.total_fee
            this.feeDisplay = `${formatFloat(res.data.distributor_price)} * ${res.data.product_count} = ${formatFloat(res.data.total_fee)}`
          }
        })
      })
    },

    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (err) return
        this.submitting = true
        createAgentPurchaseItem(Object.assign(
          {
            agent_id: this.$store.getters.userAgentId,
            goods_id: this.goodsId,
            product_type_slug: 'esim'
          },
          values
        )).then((res) => {
          this.submitting = false
          if (res.code === 0) {
            this.$router.push({ name: 'cart' })
          }
        }).catch(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.card-price-wrapper {
  max-height: 250px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }

  &::-webkit-scrollbar-track {
    background: #fff;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
  }
}

.card-select-box {
  margin: 0 10px 5px 0;
  border-radius: 0 !important;
  border: 1px solid #d9d9d9;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &.card-type-box {
    min-width: 115px;
    max-width: 240px;
  }

  &.card-shape-box {
    min-width: 105px;
    max-width: 220px;
  }
}
</style>
